import { NotificationManager } from "components/common/react-notifications";

const initialState = {
  loading: false,
  ledgerData: [],
  success: false,
  error: false,
  message: ""
};

const ledgerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LEDGER_CREATE":
    case "LEDGER_UPDATE":
    case "LEDGER_HISTORY":
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: ""
      };

    case "LEDGER_CREATE_SUCCESS":
      NotificationManager.success("", action.message || "Ledger Data Added Successfully!", 3000, null, null, "filled");

      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: "Ledger created successfully"
      };

    case "LEDGER_UPDATE_SUCCESS":
      NotificationManager.success("", action.message || "Ledger Data Updated Successfully!", 3000, null, null, "filled");

      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: "Ledger updated successfully"
      };

    case "LEDGER_HISTORY_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        ledgerData: action.data,
        message: "Ledger history fetched successfully"
      };

    case "LEDGER_CREATE_FAILED":
    case "LEDGER_UPDATE_FAILED":
    case "LEDGER_HISTORY_FAILED":
      NotificationManager.error("", action.message || "Something went wrong!", 3000, null, null, "filled");
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
        message: action.message
      };

    default:
      return state;
  }
};

export default ledgerReducer;
